export default __webpack_public_path__ + "static/media/Computer Science and Engineering.9fd934ad.pdf";